import { FC } from 'react';
import { formatCurrency } from '../../utils/format/formatCurrency';
import { Flex } from '../layout/Flex';
import { FintechDiscountBadge } from './FintechDiscountBadge/FintechDiscountBadge';
import { PayByConditionCaption } from './PayByConditionCaption/PayByConditionCaption';
import { NumberTypography } from './styles';
import { PriceProps } from './types';

export const Price: FC<PriceProps> = ({
    priceInfo,
    fintechDiscount,
    fintechDiscountOptions = {},
    personalDiscount,
    ...other
}) => {
    const discountData = fintechDiscount?.yaPay || fintechDiscount?.yaSplit;
    const hasFintechDiscount = Boolean(discountData);
    const hasPersonalDiscount = Boolean(personalDiscount?.type);
    const currentPrice = hasFintechDiscount ? discountData?.discountPrice : priceInfo?.integerPart;

    if (!currentPrice || !priceInfo?.integerPart) {
        return null;
    }

    return (
        <Flex direction="row" alignItems="center" flexWrap="wrap" spacing={0.5}>
            <NumberTypography
                variant="body"
                weight="bold"
                lines={1}
                {...other}
                color={
                    hasFintechDiscount ? 'var(--search-red)' : other.color || 'var(--color-primary)'
                }
            >
                {priceInfo.formatted
                    ? priceInfo.formatted
                    : formatCurrency(
                          currentPrice,
                          hasFintechDiscount ? priceInfo.fractionalPart : undefined,
                      )}
            </NumberTypography>
            {hasFintechDiscount && fintechDiscount ? (
                <FintechDiscountBadge
                    fintechDiscount={fintechDiscount}
                    {...fintechDiscountOptions}
                />
            ) : null}
            {!hasFintechDiscount && hasPersonalDiscount && personalDiscount ? (
                <PayByConditionCaption type={personalDiscount.type} />
            ) : null}
        </Flex>
    );
};
